import axios from "axios";
import { HEALTH_CHECK_API } from "../Constants/Apis";

export const isOnline = () => navigator.onLine;

const TIMEOUT_DURATION = 4000;

export const pingServer = async (url = HEALTH_CHECK_API) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), TIMEOUT_DURATION);

  try {
    await axios.head(url, {
      signal: controller.signal,
      validateStatus: () => true,
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
};

export const checkInternetBeforeAPI = async () => {
  if (!isOnline()) {
    return {
      canProceed: false,
      message: "You are offline! Please check your internet connection.",
    };
  }

  const isPingSuccessful = await pingServer();
  if (!isPingSuccessful) {
    return {
      canProceed: false,
      message: "Internet connection is unstable. Please try again later.",
    };
  }

  return { canProceed: true };
};
